import { Flex, Image } from "@chakra-ui/react"
import Heading from "components/UI/atoms/Heading"
import { ILoundryServicesHeaderProps } from "./LaundryServicesTypes"

const LaundryServicesAutoTypes: React.FC<ILoundryServicesHeaderProps> = ({
  title,
  imageUrl,
}) => {
  return (
    <Flex gap={"14px"} alignItems={"center"}>
      <Flex
        borderRadius={"base"}
        alignItems={"center"}
        justifyContent={"center"}
        height={"50px"}
        width={"50px"}
        background={"#E9F2FD"}
      >
        <Image src={imageUrl} alt={title}/>
      </Flex>
      <Heading variant="regular" size={"sm"} title={title} />
    </Flex>
  )
}

export default LaundryServicesAutoTypes
